// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"da950095","453":"b9a9dd03","455":"4753ae91","977":"cffe4c9d"}[chunkId] + ".chunk.js";
};